import React from "react";
import { Box } from "@mui/material";

import ShareButton from "components/ShareButton/ShareButton";

const SolutionDetailSidebarShare = ({
    data,
    isAuthenticated,
    styles,
}) => {
    return (
        <Box className={styles.detailItem} sx={{ mt: 3 }}>
            <ShareButton
                url={window.location.href}
                title={
                    data.title_english ||
                    data.title ||
                    "Untitled Solution"
                }
                description={
                    data.aims
                        ? `${data.aims.substring(0, 150)}...`
                        : "Check out this solution from the RESILIAGE Solutions Catalog"
                }
                fullWidth
                variant="outlined"
                size="large"
                disabled={!isAuthenticated}
            />
        </Box>
    );
};

export default SolutionDetailSidebarShare;